import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonRu from './locales/ru/common.json';
import commonUzLatn from './locales/uz_latn/common.json';
import commonUzCyrl from './locales/uz_cyrl/common.json';
import errorsRu from './locales/ru/errors.json';
import errorsUzLatn from './locales/uz_latn/errors.json';
import errorsUzCyrl from './locales/uz_cyrl/errors.json';
import landingRu from './locales/ru/landing.json';
import landingUzLatn from './locales/uz_latn/landing.json';
import landingUzCyrl from './locales/uz_cyrl/landing.json';
import createDealFormRu from './locales/ru/create-deal-form.json';
import createDealFormUzLatn from './locales/uz_latn/create-deal-form.json';
import createDealFormUzCyrl from './locales/uz_cyrl/create-deal-form.json';
import currenciesRu from './locales/ru/currencies.json';
import currenciesUzLatn from './locales/uz_latn/currencies.json';
import currenciesUzCyrl from './locales/uz_cyrl/currencies.json';

import { getUserLang } from '../helpers/lang';

i18n
  .use(initReactI18next)
  .init(
    {
      defaultNS: 'common',
      lng: getUserLang() ?? 'ru',
      fallbackLng: import.meta.env.DEV ? 'ru' : 'uz_latn',
      interpolation: {
        escapeValue: false,
      },
      returnObjects: true,
      cleanCode: true,
      react: {
        useSuspense: true,
      },
      resources: {
        ru: {
          common: commonRu,
          errors: errorsRu,
          landing: landingRu,
          createDealForm: createDealFormRu,
          currencies: currenciesRu,
        },
        uz_latn: {
          common: commonUzLatn,
          errors: errorsUzLatn,
          landing: landingUzLatn,
          createDealForm: createDealFormUzLatn,
          currencies: currenciesUzLatn,
        },
        uz_cyrl: {
          common: commonUzCyrl,
          errors: errorsUzCyrl,
          landing: landingUzCyrl,
          createDealForm: createDealFormUzCyrl,
          currencies: currenciesUzCyrl,
        },
      },
    },
    (error) => {
      if (error) return console.error(error);
    }
  )
  .catch((error) => Promise.reject(error));

export default i18n;
